<lib-banner
  (closeBanner)="onBannerClose()"
  [withCloseButton]="withCloseButton"
  [visible]="visible"
  [banner]="banner"
  [maxWidth]="maxWidth"
  [maxHeight]="maxHeight"
  [content]="content">
</lib-banner>
